import router from './router'
import store from './store'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import {
  getToken,
  setToken,
  getLoginMode,
  setLoginMode,
  getSnsUrl
} from '@/utils/auth'
NProgress.configure({
  showSpinner: false
})
const whiteList = ['/bind', '/scan', '/auth-redirect']
router.beforeEach(async (to, from, next) => {
  NProgress.start()
  const hasToken = getToken()
  const hasLoginMode = getLoginMode()
  if (hasToken && hasLoginMode) {
    if (to.path == '/bind') {
      next({
        path: '/',
        replace: true
      })
    } else if (to.path == '/scan') {
      next()
    } else {
      const hasRoles = store.getters.roles && store.getters.roles.length > 0
      if (hasRoles) {
        next()
      } else {
        const {
          roles
        } = await store.dispatch('user/getInfo')
        const accessRoutes = await store.dispatch('permission/generateRoutes', roles)
        router.addRoutes(accessRoutes)
        store.dispatch('settings/getConfigInfo')
        next({
          ...to,
          replace: true
        })
      }
    }
  } else {
    if (whiteList.indexOf(to.path) !== -1) {
      next()
    } else {
      if (window.navigator.userAgent.toLowerCase().match(/Alipay/i) == "alipay") {
        ap.getAuthCode({
          appId: process.env.VUE_WEB_APPID,
          scopes: ['auth_base'],
        }, async res => {
          let resL = await store.dispatch('user/login', res.authCode)
          if (resL.data.user_id || resL.data.open_id) {
            next({
              path: 'bind',
              query: {
                redirect: to.path,
                user_id: resL.data.user_id,
                ali_openid: resL.data.open_id,
                ali_unionid: resL.data.union_id
              },
              replace: true
            })
          } else {
            const {
              roles
            } = await store.dispatch('user/getInfo')
            const accessRoutes = await store.dispatch('permission/generateRoutes', roles)
            router.addRoutes(accessRoutes)
            store.dispatch('settings/getConfigInfo')
            next()
          }
        })
      } else {
        if (to.query.openid || to.query.token) {
          if (to.query.openid) {
            next({
              path: 'bind',
              query: {
                redirect: to.path,
                openid: to.query.openid
              },
              replace: true
            })
          } else {
            store.commit('user/SET_TOKEN', to.query.token)
            setToken(to.query.token)
            store.commit('user/SET_LoginMode', 'openid')
            setLoginMode('openid')
            const {
              roles
            } = await store.dispatch('user/getInfo')
            const accessRoutes = await store.dispatch('permission/generateRoutes', roles)
            router.addRoutes(accessRoutes)
            store.dispatch('settings/getConfigInfo')
            next()
          }
        } else {
          window.location.replace(getSnsUrl(window.location.href, 'snsapi_base'))
        }
      }
    }
  }
})
router.afterEach(() => {
  NProgress.done()
})



// WEBPACK FOOTER //
// ./src/permission.js